import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a23436a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "available-quota-wrap" }
const _hoisted_2 = { class: "available-quota-container" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "QuotaAdjustment__form" }
const _hoisted_5 = { class: "availableAdjustment__list" }
const _hoisted_6 = { class: "right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "当前可用额度", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "调整后可用额度", -1))
const _hoisted_9 = { class: "blueTxt" }
const _hoisted_10 = { class: "available-quota-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_radio_group, {
          value: _ctx.quotaRadio,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quotaRadio) = $event)),
          class: "availableAdjustment__radio",
          onChange: _ctx.changeQuotaRadio
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio, { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("增加额度")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio, { value: 0 }, {
              default: _withCtx(() => [
                _createTextVNode("扣减额度")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onChange"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_input_number, {
            value: _ctx.numValue,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.numValue) = $event)),
            style: {"width":"80%"},
            placeholder: "请输入正数金额"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableList, (item) => {
            return (_openBlock(), _createBlock(_component_a_button, {
              key: item,
              onClick: ($event: any) => (_ctx.changeNum(item))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, [
          _hoisted_7,
          _createTextVNode(),
          _createElementVNode("span", null, _toDisplayString(_ctx.formatCny(_ctx.rowDetail.availableAmount/ 100)), 1)
        ]),
        _createElementVNode("p", null, [
          _hoisted_8,
          _createTextVNode(),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatCny(_ctx.resNumValue)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_a_button, {
        style: {"margin-right":"14px"},
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}